import { render, staticRenderFns } from "./footer-secondary.component.vue?vue&type=template&id=452b4bb6&"
import script from "./footer-secondary.component.vue?vue&type=script&lang=ts&"
export * from "./footer-secondary.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports